export default __webpack_public_path__ + "static/media/airdockz-wht-4.b835a186.png";